var firebase = require('firebase')
require('firebase/firestore');
var config = { /* COPY THE ACTUAL CONFIG FROM FIREBASE CONSOLE */
  apiKey: 'AIzaSyB_5z8VrnPSAT5ly6nUFPaoq4uALusfR_o',
  authDomain: 'love-testor.firebaseapp.com',
  databaseURL: 'https://love-testor.firebaseio.com',
  projectId: 'love-testor',
  storageBucket: 'love-testor.appspot.com',
  messagingSenderId: '250978067987',
};
var fire = firebase.initializeApp(config);
// window.firebase = firebase;
module.exports = { fire };


// WEBPACK FOOTER //
// ./src/fire.js